import { Countrylist } from 'src/services/responseTypes/singleLaunchResponse';

import AdultPopup from './adultPopup';
import MandatoryRegistrationPopup from './mandatoryRegistrationPopup';
import NetworkRetryPopup from './networkRetryPopup';
import ParentalPopup from './parentalPopup';
import SingleMessagePopup from './singleMessagePopup';
import SubscriptionNudge from './subscriptionNudge';
import SvodOrTvodPopup from './svodOrTvodPopup';
import TobaccoAdvisory from './tobaccoAdvisory';

type PlayerPopUpsProps = {
  playerRef: any;
  countryList: Countrylist | undefined;
  popupProps: any;
  closePopUp: any;
  toggleTeaserSubscriptionPopup: any;
};

const PlayerPopupsWrapper = ({
  playerRef,
  countryList,
  popupProps,
  closePopUp,
  toggleTeaserSubscriptionPopup
}: PlayerPopUpsProps) => {
  let popupType = null;
  let additionalClass = '';
  const { singlePlayDetails = {}, playerConfig = {} } = playerRef || {};
  const { entitlement: { isTVOD = 0 } = {} } = singlePlayDetails || {};
  switch (popupProps.name) {
    case 'svodOrTvod':
      {
        const { tvodObj = null } = playerConfig || {};
        const isTVODFlag = isTVOD || singlePlayDetails.error_code === '604';
        if (isTVODFlag || tvodObj) {
          // added condition to remove purple background for tvod channel and video
          const isEvent = tvodObj && tvodObj.isTvodEvent;
          additionalClass = !isEvent ? 'tvodOverlay' : '';
        }
        popupType = (
          <SvodOrTvodPopup
            playerRef={playerRef}
            closePopUp={closePopUp}
            toggleTeaserSubscriptionPopup={toggleTeaserSubscriptionPopup}
          />
        );
      }
      break;
    case 'mandatoryRegistration':
      popupType = (
        <MandatoryRegistrationPopup
          playerRef={playerRef}
          closePopUp={closePopUp}
        />
      );
      break;
    case 'parentalPopup':
      popupType = (
        <ParentalPopup playerRef={playerRef} closePopUp={closePopUp} />
      );
      break;
    case 'adultPopup':
      popupType = (
        <AdultPopup
          popupProps={popupProps}
          closePopUp={closePopUp}
          countryList={countryList}
        />
      );
      break;
    case 'networkRetry':
      popupType = (
        <NetworkRetryPopup playerRef={playerRef} popupProps={popupProps} />
      );
      break;
    case 'singleMessagePopup':
      popupType = (
        <SingleMessagePopup playerRef={playerRef} popupProps={popupProps} />
      );
      break;
    case 'tobaccoAdvisory':
      popupType = (
        <TobaccoAdvisory closePopUp={closePopUp} popupProps={popupProps} />
      );
      break;
    case 'subscriptionNudge':
      popupType = (
        <SubscriptionNudge
          playerRef={playerRef}
          closePopUp={closePopUp}
          toggleTeaserSubscriptionPopup={toggleTeaserSubscriptionPopup}
        />
      );
      additionalClass = 'subscription-nudge-container';
      break;
    default:
      break;
  }
  return (
    <div className={`main-container ${additionalClass}`} id="main-container">
      {popupType}
    </div>
  );
};

export default PlayerPopupsWrapper;
